
export default function CaseStudiesSection() {
  const cases = [
    {
      company: 'TechStart SL',
      industry: 'SaaS Technology',
      challenge: 'Generar leads cualificados y reducir el coste de adquisición de clientes',
      solution: 'Implementamos una estrategia SEO con IA + campañas automatizadas en Google Ads',
      results: {
        leads: '+350%',
        cost: '-65%',
        revenue: '+420%'
      },
      image: 'https://public.readdy.ai/ai/img_res/fdf8b1e54a229a2102a8c153ecb6a2bb.jpg',
      testimonial: 'DigitalAI transformó completamente nuestro funnel de ventas. Los resultados superaron todas nuestras expectativas.',
      author: 'Pedro Sánchez, CEO TechStart'
    },
    {
      company: 'EcoCommerce',
      industry: 'E-commerce Sostenible',
      challenge: 'Aumentar las ventas online y mejorar la retención de clientes',
      solution: 'Marketing automation con IA + retargeting inteligente + content marketing',
      results: {
        sales: '+280%',
        retention: '+150%',
        roi: '450%'
      },
      image: 'https://readdy.ai/api/search-image?query=Sustainable%20e-commerce%20warehouse%20with%20eco-friendly%20products%2C%20green%20and%20natural%20lighting%2C%20modern%20logistics%20facility%20with%20plants%20and%20sustainable%20packaging%2C%20clean%20professional%20environment&width=600&height=400&seq=ecommerce-case&orientation=landscape',
      testimonial: 'El equipo de DigitalAI no solo mejoró nuestras ventas, sino que revolucionó toda nuestra estrategia digital.',
      author: 'Laura Jiménez, Marketing Director'
    },
    {
      company: 'FinanceVision',
      industry: 'Fintech',
      challenge: 'Posicionarse como líder en el sector fintech español',
      solution: 'SEO técnico avanzado + thought leadership content + LinkedIn Ads con IA',
      results: {
        traffic: '+500%',
        leads: '+220%',
        authority: 'Top 3'
      },
      image: 'https://readdy.ai/api/search-image?query=Modern%20fintech%20company%20office%20with%20financial%20data%20displays%2C%20contemporary%20banking%20technology%20workspace%20with%20blue%20lighting%20and%20glass%20surfaces%2C%20professional%20financial%20services%20environment&width=600&height=400&seq=finance-case&orientation=landscape',
      testimonial: 'Gracias a DigitalAI, ahora somos reconocidos como una de las fintech más innovadoras de España.',
      author: 'Miguel Torres, Founder FinanceVision'
    }
  ];

  const [activeCase, setActiveCase] = useState(0);

  return (
    <section id="casos" className="py-20 bg-gray-50">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-800 mb-4">
            Casos de Éxito Reales
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Descubre cómo hemos ayudado a empresas como la tuya a alcanzar resultados extraordinarios 
            combinando marketing digital con inteligencia artificial
          </p>
        </div>

        <div className="flex flex-wrap justify-center mb-8 gap-4">
          {cases.map((case_, index) => (
            <button
              key={index}
              onClick={() => setActiveCase(index)}
              className={`px-6 py-3 rounded-full transition-all whitespace-nowrap cursor-pointer ${
                activeCase === index
                  ? 'bg-blue-600 text-white shadow-lg'
                  : 'bg-white text-gray-600 hover:bg-gray-100'
              }`}
            >
              {case_.company}
            </button>
          ))}
        </div>

        <div className="bg-white rounded-2xl shadow-2xl overflow-hidden">
          <div className="grid grid-cols-1 lg:grid-cols-2">
            <div className="relative h-64 lg:h-full">
              <img 
                src={cases[activeCase].image}
                alt={cases[activeCase].company}
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-r from-blue-600/20 to-purple-600/20"></div>
            </div>
            
            <div className="p-8 lg:p-12">
              <div className="flex items-center mb-6">
                <h3 className="text-2xl font-bold text-gray-800 mr-4">{cases[activeCase].company}</h3>
                <span className="bg-blue-100 text-blue-600 px-3 py-1 rounded-full text-sm">
                  {cases[activeCase].industry}
                </span>
              </div>
              
              <div className="space-y-6">
                <div>
                  <h4 className="font-semibold text-gray-800 mb-2 flex items-center">
                    <i className="ri-question-line text-red-500 mr-2"></i>
                    Desafío
                  </h4>
                  <p className="text-gray-600">{cases[activeCase].challenge}</p>
                </div>
                
                <div>
                  <h4 className="font-semibold text-gray-800 mb-2 flex items-center">
                    <i className="ri-lightbulb-line text-yellow-500 mr-2"></i>
                    Solución
                  </h4>
                  <p className="text-gray-600">{cases[activeCase].solution}</p>
                </div>
                
                <div>
                  <h4 className="font-semibold text-gray-800 mb-4 flex items-center">
                    <i className="ri-trophy-line text-green-500 mr-2"></i>
                    Resultados
                  </h4>
                  <div className="grid grid-cols-3 gap-4">
                    {Object.entries(cases[activeCase].results).map(([key, value], index) => (
                      <div key={index} className="text-center bg-gray-50 rounded-lg p-4">
                        <div className="text-2xl font-bold text-blue-600">{value}</div>
                        <div className="text-sm text-gray-500 capitalize">{key}</div>
                      </div>
                    ))}
                  </div>
                </div>
                
                <div className="bg-gray-50 rounded-lg p-6">
                  <p className="text-gray-700 italic mb-4">"{cases[activeCase].testimonial}"</p>
                  <p className="text-sm text-gray-500 font-medium">{cases[activeCase].author}</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="text-center mt-12">
          <h3 className="text-2xl font-bold text-gray-800 mb-4">
            ¿Quieres ser nuestro próximo caso de éxito?
          </h3>
          <p className="text-gray-600 mb-6">
            Agenda una consulta gratuita y descubre cómo podemos transformar tu negocio
          </p>
          <button 
            onClick={() => window.open('https://calendly.com/clientesdatametanoia/30min', '_blank')}
            className="bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 text-white px-8 py-4 rounded-lg text-lg transition-all whitespace-nowrap cursor-pointer"
          >
            <i className="ri-calendar-line mr-2"></i>
            Agendar Consulta Gratuita
          </button>
        </div>
      </div>
    </section>
  );
}
